import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import gql from 'graphql-tag';

@Injectable()
export class BookingsQueryService {

    public GET_SCHEDULE_BOOKING_BY_ORDERID: any;

    constructor(public apollo: Apollo) {

        // Get data from schedule booking for updating insReportId
        this.GET_SCHEDULE_BOOKING_BY_ORDERID =
            gql`                                
            query GetReturnSelectedId($insReportId:String!) {
                allScheduledBookings(condition:{insReportId:$insReportId}) {
                    edges {
                        node {
                            buyerProperty
                            assignedTo
                            scheduleBookingId
                        }
                    }
                }
            }
 
     `;
    }

    // Check this report already saved or not 
    getBuyerProperty(): any {
        return this.apollo
            .watchQuery({
                query: this.GET_SCHEDULE_BOOKING_BY_ORDERID
                ,
                variables:
                {
                    'insReportId': window.localStorage.getItem('reportId').trim(),
                },
                fetchPolicy: 'network-only'
            });
    }


}


// WEBPACK FOOTER //
// /vercel/path0/src/app/main/content/gql-query-mutation/schedule-bookings.service.ts